<template>
    <ActionBar :fixed="true" :style="{ 'height': '80px' }">
        <div :class="{ 'flex justify-end': !xs }" class="container w-100">
            <div :class="{ 'w-30': !xs }">
                <TooliabaButton :enabled="enabled" @click="$emit('click')" >{{text}}</TooliabaButton>
            </div>
        </div>
    </ActionBar>
</template>

<script>
import ActionBar from '@/components/global/ActionBar.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    components: {
        ActionBar,
        TooliabaButton
    },
    props: {
        text: {
            type: String,
            required: true
        },
        enabled: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>
